import React from 'react';
import Table from 'src/ui/library/Table';
import { TableGetChildren } from '../../elements/TableFactoryHelpers';

class SelectTable extends React.Component {
  onTableChange = (actionType, data) => {
    if (actionType === 'rowSelected') {
      const { selectedRows } = data.model;
      const selectedKeys = selectedRows
        .map(row => row.origRowIndex)
        .reduce((acc, next) => {
          acc[next + 1] = true;
          return acc;
        }, {});

      const { tableHeadElements, elementActions } = this.props;
      const { tableElements } = TableGetChildren(tableHeadElements, elementActions);

      tableElements.forEach(tableEl => {
        tableEl.isRowSelected = typeof selectedKeys[tableEl.origRowIndex] !== 'undefined' ? true : false;
      });

      // update the parser state with the latested selected rows
      const { setFormValues } = elementActions();
      setFormValues();
    }
  };

  render() {
    const {
      label,
      setUpdateModelFn,
      addNewRowFn,
      elementActions,
      deleteRowsFn,
      cancelRowsFn,
      setTableModelFn,
      setCancelSelectedRows,
      setUpdateColumnFn,
      ...otherProps
    } = this.props;

    return (
      <div className={'horizontal-table'}>
        <span className={'table-label'}>{label}</span>
        <Table
          updateModel={setUpdateModelFn}
          setTableModel={setTableModelFn}
          updateColumn={setUpdateColumnFn}
          onTableChange={this.onTableChange}
          cancelSelectedRows={setCancelSelectedRows}
          {...otherProps}
        />
      </div>
    );
  }
}

export default SelectTable;
